export const ACCESS_REQUESTS_FETCH = 'ACCESS_REQUESTS_FETCH'
export const ACCESS_REQUESTS_FETCH_RESPONSE = 'ACCESS_REQUESTS_FETCH_RESPONSE'

export const ACCESS_REQUESTS_APPROVE = 'ACCESS_REQUESTS_APPROVE'
export const ACCESS_REQUESTS_APPROVE_RESPONSE = 'ACCESS_REQUESTS_APPROVE_RESPONSE'
export const ACCESS_REQUESTS_APPROVE_ERROR = 'ACCESS_REQUESTS_APPROVE_ERROR'

export const ACCESS_REQUESTS_SET_STATUS = 'ACCESS_REQUESTS_SET_STATUS'
export const ACCESS_REQUESTS_DROP_STATUS = 'ACCESS_REQUESTS_DROP_STATUS'

export const ACCESS_REQUESTS_DECLINE = 'ACCESS_REQUESTS_DECLINE'
export const ACCESS_REQUESTS_DECLINE_REQUEST = 'ACCESS_REQUESTS_DECLINE_REQUEST'
export const ACCESS_REQUESTS_DECLINE_RESPONSE = 'ACCESS_REQUESTS_DECLINE_RESPONSE'
